import { fetchDeviceQrcode } from 'api'
import { getDeviceQrCodeCache, setDeviceQrCodeCache } from 'utils/deviceQrCodeCache'

const QRCODE_FETCH_TIMEOUT = 5 * 1000

export async function fetchDeviceQrcodeWithCache(): Promise<{ code: string } | null> {
  const cachedQrCode = getDeviceQrCodeCache()
  try {
    const controller = new AbortController()
    const signal = controller.signal
    // timeout if we have cached qrcode in case of safari debug in pendeing forever
    if (cachedQrCode != null) {
      setTimeout(() => {
        controller.abort()
      }, QRCODE_FETCH_TIMEOUT)
    }
    const data = await fetchDeviceQrcode(signal)
    setDeviceQrCodeCache(data.code)
    return data
  } catch (error) {
    if (cachedQrCode) {
      return { code: cachedQrCode }
    }
    console.error(error)
    return null
  }
}
